// extracted by mini-css-extract-plugin
module.exports = {"templateContainer":"HeroPromoImage_templateContainer__3-nma","row":"HeroPromoImage_row__3WA8t","foregroundImage":"HeroPromoImage_foregroundImage__AUhbi"};